import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../../_metronic/layout/core'
import ProductTable from './components/ProductTable'
import ProductForm from './components/ProductForm'

const crmBreadcrumb: PageLink = { title: 'CRM', path: '/', isSeparator: false, isActive: false }
const crmProductBreadcrumb: PageLink = {
    title: 'Product',
    path: '/crm/product',
    isSeparator: false,
    isActive: true,
}

const ProductPage: React.FC = () => {
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route
                    path='/'
                    element={
                        <>
                            <PageTitle breadcrumbs={[crmBreadcrumb]}>Product</PageTitle>
                            <ProductTable />
                        </>
                    }
                />
                <Route
                    path='/add'
                    element={
                        <>
                            <PageTitle breadcrumbs={[crmBreadcrumb, crmProductBreadcrumb]}>Add Product</PageTitle>
                            <ProductForm />
                        </>
                    }
                />
                <Route
                    path='/edit/:id'
                    element={
                        <>
                            <PageTitle breadcrumbs={[crmBreadcrumb, crmProductBreadcrumb]}>Edit Product</PageTitle>
                            <ProductForm />
                        </>
                    }
                />
            </Route>
            <Route path='*' element={<Navigate to='/error/404' />} />
        </Routes>
    )
}

export default ProductPage
